import { useState } from 'react'
import GameRoomsCard from './GameRoomsCard'
// import Ticker from '../Component/Ticker'
import Pagination from '../Component/Pagination'
import { Link, useSearchParams } from 'react-router-dom'
import { useApiGet } from '../api/apiHooks'
import { getAliasLeaguesUrl, getGameRoomsUrl } from '../api/urls'
import Tabs from '../Component/Tabs'
import './GRStyle.css'
import CustomSelect from '../Component/CustomSelect.jsx'
import footballImg from '../assets/football.png'
import GameRoomsCardSkeleton from '../Component/SkeletonLoaders/GameRoomsCardSkeleton.jsx'
import Skeleton from 'react-loading-skeleton'
import GameroomsAd from '../Advertisement/GameroomsAd.jsx'
import { AAds } from '../Advertisement/AdConfig.js'

export default function GameRooms() {
  const [searchParams, setSearchParams] = useSearchParams()
  const selectedTab = searchParams.get('tab') || 'open'
  const pageNo = parseInt(searchParams.get('pageNo')) || 1
  const [leagueId, setLeagueId] = useState(null)

  const { isLoading: isLoadingLeagues, data: aliasLeagues } = useApiGet({
    queryKey: [getAliasLeaguesUrl()],
  })

  const status = selectedTab === 'all' ? null : selectedTab
  const { isLoading: isLoadingGameRooms, data: gameRooms } = useApiGet({
    queryKey: [
      getGameRoomsUrl({ league: leagueId, status, page: pageNo, take: 10 }),
    ],
    hasPagination: true,
  })

  // tabData values are based on endpoint filter and label are for show  in the UI
  const tabsData = [
    { id: 3, label: 'Open' },
    { id: 2, label: 'Upcoming' },
    { id: 5, label: 'Live' },
    { id: 6, label: 'Completed' },
    { id: 1, label: 'All' },
  ]

  const handleTabSelection = (newTab) => {
    setSearchParams({ tab: newTab.label.toLowerCase(), pageNo: 1 })
  }

  const setPage = (page) => {
    setSearchParams({ tab: selectedTab, pageNo: page })
  }

  // All League initially selected
  const leagueOption = [
    { label: 'All Leagues', value: null, imgSrc: footballImg },
  ].concat(
    aliasLeagues?.map((league) => ({
      label: league.name,
      value: league.id,
      imgSrc: league.logo,
    })) || []
  )

  const handleLeagueChange = (selectedOption) => {
    setLeagueId(selectedOption.value)
  }

  return (
    <>
      <div className='GameRoomBanner'>
        <h2 className='u-capitalize'>Game Rooms</h2>
        {isLoadingLeagues ? (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Skeleton width={250} height={50} />
          </div>
        ) : (
          <CustomSelect options={leagueOption} onChange={handleLeagueChange} />
        )}
      </div>

      <div className='cards-container' style={{ paddingBottom: '100px' }}>
        <Tabs
          tabsData={tabsData}
          selectedTab={selectedTab}
          handleTabSelection={handleTabSelection}
        />

        {isLoadingGameRooms ? (
          <>
            {[...Array(5)].map((_, idx) => (
              <GameRoomsCardSkeleton key={idx} />
            ))}
          </>
        ) : (
          <div>
            {gameRooms?.data?.length > 0 ? (
              gameRooms?.data?.map((item, index) => {
                return (
                  <Link to={`/game-rooms/${item.id}`} key={index}>
                    <GameRoomsCard
                      isGR_heroSection={false}
                      GRDetails={item}
                      hasJoined={item.joinGameRoom === null ? false : true}
                    />
                  </Link>
                )
              })
            ) : (
              <div style={{ textAlign: 'center', color: 'gray' }}>
                No Game Room found for this league
              </div>
            )}
          </div>
        )}
        {!isLoadingGameRooms && gameRooms?.data?.length > 0 && (
          <Pagination pagination={gameRooms?.pagination} setPageNo={setPage} />
        )}

        <GameroomsAd AdUnitId={AAds.GameRoomsAdUnitId} />
      </div>
    </>
  )
}
